import React from 'react'
import { Link } from 'react-router-dom';

import { Me, Divider, Pattern } from "../img";

import "../css/about.css";
const AboutHeader = () => {
    return (
      <div className="aboutHeader" id="aboutHeader">
        <Link to="/about">
          <h1>About Me</h1>
        </Link>
        <img src={Divider} alt="wavy line" className="divider" />

        <div className="grid">
          <span className="txtBox">
            <h1>نبذه عن الفنان حسام ربيع</h1>

            <p>
              سيدة نوبية تغزل غطاء رأس لطفل صغير بسوق أسوان إلتقطها الفنان حسام ربيع بسرعة البرق بدون أن يلاحظه أحد من مرتادى السوق لأنهم يكرهون تصوير أنثاهم فى بعض الأحيان وقد
            </p>
            <p>
              حازت هذه اللوحة على الجائزة الشرفية الأولى بصالون الجنوب الدولى الرابع والذى نظمته كلية الفنون الجميلة بالأقصر والتى كانت تتبع جامعة جنوب الوادى فى ذلك الوقت
            </p>

            <Link to="/about" className="styledBtns">المذيد</Link>
          </span>

          <span className="imgBox">
            <img src={Me} alt="Hossam Rabei" className="me" />
            <img src={Pattern} alt="Some pattern" className="pattern" />
          </span>
        </div>

        {/* <div className="grid">
          <span className="imgBox">
            <img src={Me} alt="Hossam Rabei" className="me" />
            <img src={Pattern} alt="Some pattern" className="pattern" />
          </span>

          <span className="txtBox">
            <h1>We can make it together</h1>

            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic sunt
              neque vitae harum consequuntur nam fugiat aperiam iure aut
              facilis.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic sunt
              neque vitae harum consequuntur nam fugiat aperiam iure aut
              facilis.
            </p>

            <Link to="/about" className="styledBtns">
              Read More
            </Link>
          </span>
        </div> */}
      </div>
    );
}

export default AboutHeader
